class ProductCrossSell extends HTMLElement {
  constructor() {
    super();

    this.csp_element = document.querySelector(
      "#cross-sell-product-data script"
    );
    this.cross_sell_json;
    this.required_cross_sell_products = [];
    this.cross_sell_products = [];
    if (this.csp_element) {
      this.cross_sell_json = JSON.parse(this.csp_element.innerHTML);
    }

    this.cartDrawer = document.querySelector("cart-drawer");

    console.log("ProductCrossSell", this.cross_sell_json);
  }

  async connectedCallback() {
    await this.loadProducts();
  }

  async loadProducts() {
    if (this.cross_sell_json) {
      const sortedArray = [
        ...this.cross_sell_json.products.filter(
          ({ relationship_type }) => relationship_type !== "required"
        ),
        ...this.cross_sell_json.products.filter(
          ({ relationship_type }) => relationship_type === "required"
        ),
      ];

      const requiredItems = sortedArray.filter((data) => {
        return (
          data.relationship_type === "required" &&
          data.shopify_product.id !== null
        );
      });

      document.querySelector(".js-csp-required-title").textContent =
        requiredItems.length === 1
          ? "You'll need this..."
          : "You'll need these...";

      if (requiredItems.length >= 1) {
        document.querySelector(".js-required-block").classList.remove("hidden");
      }

      const CSJ = sortedArray.filter((data) => {
        return (
          data.relationship_type !== "required" &&
          data.shopify_product.id !== null
        );
      });

      if (CSJ.length >= 1) {
        document.querySelector(".js-csp-block").classList.remove("hidden");
      }

      const getTemplate = (csp, product) => {
        console.log("getTemplate", product);
        let variant = product.variants.filter((f) => f.sku === csp.sku)[0];
        let product_img = variant.featured_image.src;

        let csp_badge = "";

        if (csp.relationship_type === "required") {
          csp_badge = `<div class="bg-red-600 inline-block whitespace-nowrap rounded text-gray-100 text-xs px-2 py-1 absolute top-1 left-1">
              Required
          </div>`;
        } else if (csp.relationship_type === "compatible") {
          csp_badge = `<div class="bg-black inline-block whitespace-nowrap rounded text-gray-300 text-xs px-2 py-1 absolute top-1 left-1">
              Compatible
          </div>`;
        }

        const csp_html = `<div class="h-full flex flex-col justify-between">
            <div class="relative">
              <a href="${
                product.handle
              }" class="block group w-full bg-white rounded border border-gray-200 overflow-hidden aspect-w-1 aspect-h-1">
                  <img src="${
                    product_img
                      ? "https://res.cloudinary.com/proex/image/fetch/f_auto,w_400,h_400,c_pad,b_white,q_70,dpr_auto/" +
                        variant.featured_image.src
                      : ""
                  }" alt="${
          product.title
        }" class="p-2 w-full h-full object-center object-cover group-hover:opacity-75">
              </a>
              ${csp_badge}
              <a href="${
                product.handle
              }" class="text-primary-500 block tracking-tight leading-0 text-xs my-3">${
          product.title
        }
              </a>
            </div>
          <div>
        <div class="whitespace-nowrap text-gray-500 text-sm mb-3">$${parseFloat(
          variant.price / 100
        ).toFixed(2)}</div>
        ${
          variant.available
            ? `<button data-variant-id="${variant.id}" data-title="${
                product.title
              }" data-image="${
                product_img ? variant.featured_image.src : ""
              }" class="js-cross-sell-product block w-full btn-pill">Add to Cart
          </button>`
            : `<button disabled class="btn-pill block w-full opacity-50 pointer-events-none">Sold Out</button>`
        }
            </div>
    </div>`;
        return csp_html;
      };

      this.loadCrossSellProducts = async () => {
        let requiredPromises = requiredItems.map(async (csp) => {
          const product = await fetch(
            `/products/${csp.shopify_product.handle}.js`
          )
            .then((response) => response.json())
            .then((data) => data);

          if (product) {
            return getTemplate(csp, product);
          }
        });

        let cspPromises = CSJ.map(async (csp) => {
          const product = await fetch(
            `/products/${csp.shopify_product.handle}.js`
          )
            .then((response) => response.json())
            .then((data) => data);

          if (product) {
            return getTemplate(csp, product);
          }
        });

        const requiredProductResults = await Promise.all(requiredPromises);
        const csProductResults = await Promise.all(cspPromises);

        this.required_cross_sell_products = requiredProductResults;
        this.cross_sell_products = csProductResults;
      };

      this.loadCrossSellProducts().then(() => {
        let requiredHtml = "";
        for (var htmlstr in this.required_cross_sell_products) {
          requiredHtml += this.required_cross_sell_products[htmlstr];
        }

        let cspHtml = "";
        for (var htmlstr in this.cross_sell_products) {
          cspHtml += this.cross_sell_products[htmlstr];
        }

        const parser = new DOMParser();
        const requiredCards = parser.parseFromString(requiredHtml, "text/html");
        const cards = parser.parseFromString(cspHtml, "text/html");

        const requiredCrossSellContainers = document.querySelectorAll(
          ".cross-sell-required-container"
        );

        const crossSellContainers = document.querySelectorAll(
          ".cross-sell-container"
        );

        requiredCrossSellContainers.forEach((container) => {
          requiredCards.body.childNodes.forEach((card) => {
            const cs_card = card.cloneNode(true);
            container.prepend(cs_card);
          });
        });

        crossSellContainers.forEach((container) => {
          cards.body.childNodes.forEach((card) => {
            const cs_card = card.cloneNode(true);
            container.prepend(cs_card);
          });
        });

        // Add click events to add to cart
        const crossSellProducts = document.querySelectorAll(
          ".js-cross-sell-product"
        );

        crossSellProducts.forEach((product) => {
          product.addEventListener("click", (e) => {
            e.preventDefault();
            let btn = e.target;
            const image = btn.dataset.image;
            const title = btn.dataset.title;
            const body = JSON.stringify({
              items: [
                {
                  id: e.target.dataset.variantId,
                },
              ],
            });
            fetch(`${routes.cart_add_url}`, {
              ...fetchConfig("javascript"),
              body,
            })
              .then((response) => response.json())
              .then((parsedState) => {
                this.cartDrawer.loadCart();
              })
              .catch((e) => {
                console.error("cross-sell-products error", e);
              })
              .finally(() => {
                this.cartDrawer.open();
              });
          });
        });
      });
    }
  }
}

customElements.define("product-cross-sell", ProductCrossSell);
